export enum CustomerSpecification {
  A_CUSTOMER = 'A',
  B_CUSTOMER = 'B',
  C_CUSTOMER = 'C',
  D_CUSTOMER = 'D',
  VIP_CUSTOMER = 'VIP',
  LEAD = 'lead'
}
